import { Checkbox, Tooltip } from "antd";
import { Fragment } from "react";
import LinkOrSpan from "../links/LinkOrSpan/LinkOrSpan";
import { DataRecord, RowRendererProps } from "./Table";
import styles from "./Table.module.scss";

export default function Row<R extends DataRecord>({
  record,
  columns,
  gridTemplateColumns,
  rowKey,
  rowLink,
  onRowClick,
  selectedKeys,
  onChangeCheckbox,
  activeRowKey,
  className,
}: RowRendererProps<R>) {
  return (
    <div
      className={[
        styles.row,
        className,
        activeRowKey && activeRowKey === record[rowKey] && styles.active,
      ].join(" ")}
      style={{ gridTemplateColumns }}
    >
      {columns.map((column) => {
        return (
          <Fragment key={column.key}>
            <Tooltip
              title={column.cellTooltip?.(record, column.key)}
              key={column.key}
            >
              {column.type === "checkbox" ? (
                <div
                  className={styles.column}
                  {...column.cellProps?.(record, column.key)}
                >
                  <div className={styles.wrapper}>
                    <Checkbox
                      value={record[rowKey]}
                      checked={selectedKeys?.includes(record[rowKey])}
                      onChange={onChangeCheckbox}
                    />
                  </div>
                </div>
              ) : (
                <LinkOrSpan
                  onClick={() => onRowClick?.(record)}
                  to={column.noLink ? undefined : rowLink?.(record)}
                  className={[styles.column, onRowClick && styles.pointer].join(" ")}
                  {...column.cellProps?.(record, column.key)}
                >
                  <div className={[styles.wrapper, styles[column.align || "start"]].join(" ")}>
                    {column.renderer ? column.renderer(record, column.key) : record?.[column.key]}
                  </div>
                </LinkOrSpan>
              )}
            </Tooltip>
          </Fragment>
        );
      })}
    </div>
  );
}
